import React, { Suspense } from 'react';

const LoginPage = React.lazy(() => import('pages/auth/login'));
const ForgotPasswordPage = React.lazy(() => import('pages/auth/forgot'));
const RecoverAccountPage = React.lazy(() => import('pages/auth/recover'));

export const definitions = [
  {
    path: 'login',
    component: <LoginPage />
  },
  {
    path: 'forgot',
    component: <ForgotPasswordPage />
  },
  {
    path: 'recover/:recoverCode',
    component: <RecoverAccountPage />
  }
];